/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceDefinitionNode } from './ServiceDefinitionNode';
import {
    ServiceDefinitionNodeFromJSON,
    ServiceDefinitionNodeFromJSONTyped,
    ServiceDefinitionNodeToJSON,
    ServiceDefinitionNodeToJSONTyped,
} from './ServiceDefinitionNode';

/**
 * 
 * @export
 * @interface CreateServiceAgreementRequest
 */
export interface CreateServiceAgreementRequest {
    /**
     * 
     * @type {ServiceDefinitionNode}
     * @memberof CreateServiceAgreementRequest
     */
    serviceDefinition: ServiceDefinitionNode;
    /**
     * List of existing Contact Note UUIDs to associate with the newly created Service Agreement. When omitted or empty, no contact notes will be associated. Optional in general, but at least one non-null UUID is required when creating a product for an ACTIVE PRIVATE_BANKING business relation; such a request without a contact note is rejected with 403.
     * 
     * @type {Array<string>}
     * @memberof CreateServiceAgreementRequest
     */
    contactNoteUids?: Array<string>;
}

/**
 * Check if a given object implements the CreateServiceAgreementRequest interface.
 */
export function instanceOfCreateServiceAgreementRequest(value: object): value is CreateServiceAgreementRequest {
    if (!('serviceDefinition' in value) || value['serviceDefinition'] === undefined) return false;
    return true;
}

export function CreateServiceAgreementRequestFromJSON(json: any): CreateServiceAgreementRequest {
    return CreateServiceAgreementRequestFromJSONTyped(json, false);
}

export function CreateServiceAgreementRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateServiceAgreementRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceDefinition': ServiceDefinitionNodeFromJSON(json['serviceDefinition']),
        'contactNoteUids': json['contactNoteUids'] == null ? undefined : json['contactNoteUids'],
    };
}

export function CreateServiceAgreementRequestToJSON(json: any): CreateServiceAgreementRequest {
    return CreateServiceAgreementRequestToJSONTyped(json, false);
}

export function CreateServiceAgreementRequestToJSONTyped(value?: CreateServiceAgreementRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceDefinition': ServiceDefinitionNodeToJSON(value['serviceDefinition']),
        'contactNoteUids': value['contactNoteUids'],
    };
}

